import { gatewayApiClient } from '../../_shared/api/gatewayApiClient';
import type { CursorResponse, RequestLogDto, RequestLogFilters } from '../types/requestLog';

export interface RequestLogsParams extends RequestLogFilters {
  cursor?: string | null;
}

export const requestLogsApi = {
  /**
   * GET /api/eraf/gateway/admin/request-logs
   * Returns ApiResponse<CursorResponse<RequestLogDto>>.
   * gatewayApiClient response interceptor unwraps the ApiResponse envelope,
   * so response.data is already CursorResponse<RequestLogDto>.
   */
  list: async (params: RequestLogsParams): Promise<CursorResponse<RequestLogDto>> => {
    // Remove empty/null params to keep query string clean
    const cleanParams: Record<string, string | number> = {};
    if (params.from) cleanParams.from = params.from;
    if (params.to) cleanParams.to = params.to;
    if (params.routeId) cleanParams.routeId = params.routeId;
    if (params.status) cleanParams.status = params.status;
    if (params.statusClass) cleanParams.statusClass = params.statusClass;
    if (params.ip) cleanParams.ip = params.ip;
    if (params.userId) cleanParams.userId = params.userId;
    if (params.traceId) cleanParams.traceId = params.traceId;
    if (params.cursor) cleanParams.cursor = params.cursor;
    if (params.size) cleanParams.size = params.size;

    const response = await gatewayApiClient.get<CursorResponse<RequestLogDto>>(
      '/admin/request-logs',
      { params: cleanParams },
    );
    return response.data;
  },
};
